import { de } from './de';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { Language, Translations } from './types';

export const translations: Record<Language, Translations> = {
  de,
  en,
  es,
  fr,
};

export type { Language, Translations } from './types';